module.exports = __webpack_public_path__ + "img/cosmoplay.acf1202f.jpg";